// resources/js/Pages/Formula/InspectorSidebar.js
import React from 'react';
import PropertiesPane from './PropertiesPane'; // Reusing the existing properties editor

export default function InspectorSidebar({
  selectedNode,
  variables,
  onPatchNode,
  onConvertToArray
}) {
  const isRootSelected = !selectedNode || selectedNode.type === 'root';

  return (
    <div style={{ maxHeight: 'calc(100vh - 150px)', overflowY: 'auto' }}>
      {isRootSelected ? (
        <div className="text-center text-muted p-4">
          <div style={{ fontSize: '2rem' }}>🎨</div>
          <h6>Visual Editor Inspector</h6>
          <p className="small">Select an element on the canvas to see its properties here.</p>
        </div>
      ) : (
        // We reuse the existing PropertiesPane to show the details
        <PropertiesPane
          node={selectedNode}
          variables={variables}
          onChange={onPatchNode}
          onConvertToArray={onConvertToArray}
        />
      )}
    </div>
  );
}